module.exports = __webpack_public_path__ + "images/stickers/pete-love@2x.20a442732d8123e037a9.png";